import type { Project } from "../data/site";

type ProjectMediaProps = {
  project: Project;
  priority?: boolean;
};

export function ProjectMedia({ project, priority = false }: ProjectMediaProps) {
  return (
    <>
      <img
        className="project-media__image"
        src={project.image.src}
        alt={project.image.alt}
        width={project.image.width}
        height={project.image.height}
        decoding="async"
        fetchPriority={priority ? "high" : undefined}
        loading={priority ? "eager" : "lazy"}
        data-media-kind={project.image.kind}
      />
      <span className="project-media__scrim" aria-hidden="true" />
      <span
        className="project-media__label"
        data-media-kind={project.image.kind}
      >
        {project.image.label}
      </span>
    </>
  );
}
